import { Option } from '../../general-types';
import { ValueOfKey } from '../../utils-types';

export const ENTITY_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  INCOMPLETE: 'INCOMPLETE',
  PAYMENT_ISSUE: 'PAYMENT_ISSUE',
  DEACTIVATED: 'DEACTIVATED',
  /* ScanIQ solution is not defined we get this status */
  UNDEFINED: 'UNDEFINED',
} as const;

export type EntityStatus = ValueOfKey<typeof ENTITY_STATUS>;

export const entityStatusOption: Option<EntityStatus | ''>[] = [
  { label: 'All', value: '' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Incomplete', value: 'INCOMPLETE' },
  { label: 'Payment Issue', value: 'PAYMENT_ISSUE' },
  { label: 'Deactivated', value: 'DEACTIVATED' },
];
